import {
    useMixedGroupedFilteredStoreCreator,
    UseMixedGroupedStore,
} from '../mixed-grouped.store';
import { UseSimpleStore } from '@om-fe/store';
import { MixedGroupedTournamentModel } from '../mixed-grouped.types';

export function useMixedGroupedOutrightsStoreCreator(
    mixedStore: UseMixedGroupedStore,
): UseSimpleStore<MixedGroupedTournamentModel> {
    return useMixedGroupedFilteredStoreCreator(mixedStore, 'outrightsList');
}
